import { useGradientId } from '@internal/plugin-waadoo-core';

// Séparé de `components/ui/icons/terminalIcons.tsx` (qui décrit les deux
// icônes de terminal) à l'étape 9c du plan « plateforme d'applications »,
// pour rejoindre le module Odoo (étape 9e).

/**
 * The Odoo shell: a slate window, a cyan `>_` prompt. The window's class
 * gives it its outline in dark mode (styles.css), where the slate would
 * otherwise melt into the dark surfaces.
 */
export function OdooShellIcon() {
  const gradientId = useGradientId('waadoo-odoo-shell-gradient');
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#334155" />
          <stop offset="1" stopColor="#0f172a" />
        </linearGradient>
      </defs>
      <rect
        className="waadoo-odoo-shell-icon__window"
        x="1.5"
        y="3"
        width="21"
        height="18"
        rx="4.5"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M6 9l3.5 3L6 15"
        fill="none"
        stroke="#22d3ee"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="11"
        y="14"
        width="7"
        height="2.2"
        rx="1.1"
        fill="#22d3ee"
        opacity=".85"
      />
    </svg>
  );
}
